/**
 * @link https://mui.com/material-ui/react-switch/
 */

import {FormGroup, FormControlLabel, Switch} from "@mui/material";
import React from "react";
import ShowCode from "../../helpers/ShowCode.js";

export default function FactureeSwitch() {
  return (
    <>
      <FormGroup>
        <FormControlLabel control={<Switch defaultChecked />} label="Active" />
        <FormControlLabel disabled control={<Switch />} label="Disabled" />
      </FormGroup>
      <br/>
      <br/>
      
      <ShowCode 
        codeString={`<>
  {/* Basic Switches */}
  <FormGroup>
    <FormControlLabel control={<Switch defaultChecked />} label="Active" />
    <FormControlLabel control={<Switch />} label="Inactive" />
    <FormControlLabel disabled control={<Switch />} label="Disabled" />
    <FormControlLabel disabled control={<Switch defaultChecked />} label="Disabled Checked" />
  </FormGroup>
  
  {/* Color variants */}
  <FormGroup>
    <FormControlLabel control={<Switch defaultChecked color="primary" />} label="Primary" />
    <FormControlLabel control={<Switch defaultChecked color="secondary" />} label="Secondary" />
    <FormControlLabel control={<Switch defaultChecked color="success" />} label="Success" />
    <FormControlLabel control={<Switch defaultChecked color="error" />} label="Error" />
    <FormControlLabel control={<Switch defaultChecked color="warning" />} label="Warning" />
    <FormControlLabel control={<Switch defaultChecked color="info" />} label="Info" />
  </FormGroup>
  
  {/* Size variants */}
  <FormGroup>
    <FormControlLabel control={<Switch defaultChecked size="small" />} label="Small" />
    <FormControlLabel control={<Switch defaultChecked />} label="Medium (default)" />
  </FormGroup>
</>`} 
        scope={{ 
          React, 
          FormGroup, 
          FormControlLabel, 
          Switch 
        }} 
      />
    </>
  )
}